function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", {
  id: "defs8"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "m 25.272709,1217.3365 -1.489,-1.639 -1.639,1.786 -1.637,-1.935 -1.639,1.935 -1.489,-2.084 c 0,0 -1.191,1.191 -1.639,1.787 -0.298,0.446 -0.744,0.596 -1.191,0.446 -1.191,-0.149 -2.085,0.149 -2.979,1.191 -1.7879998,2.086 -4.6179998,2.533 -7.1489998,1.489 -2.532,-1.042 -4.02099998,-3.425 -4.02099998,-6.255 0,-2.829 1.93699998,-5.361 4.61799998,-6.106 2.681,-0.894 5.6599998,0.149 7.2959998,2.531 0.298,0.447 0.597,0.447 1.044,0.447 h 12.063 c 0.298,0 2.235,1.639 2.83,2.383 0.149,0.149 0.149,0.895 0.149,0.895 z m -21.2979998,-1.193 c 0.895,0 1.788,-0.744 1.788,-1.786 0,-0.895 -0.744,-1.788 -1.788,-1.788 -0.893,0 -1.786,0.744 -1.786,1.788 0.149,1.042 0.893,1.786 1.786,1.786 z",
  id: "path2"
});

function SvgKey(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0.5 1200.5 28 28.000001",
    id: "svg4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKey);
export default __webpack_public_path__ + "static/media/key.3a4fc5ac.svg";
export { ForwardRef as ReactComponent };